function getDefaultAppID(userData) {
  return userData?.appsConnected?.[0];
}

export default getDefaultAppID;
